import en from "./en.json";
import it from "./it.json";

const settings = { en, it };

export default settings;
